import gql from 'graphql-tag'

import { EvaluationFragment } from '@/graphql/fragments/loans'

export const query = gql`
  ${EvaluationFragment}
  query fetchEvaluation($id: Int!) {
    records: loans_evaluation_by_pk(id: $id) {
      ...Evaluation
    }
  }
`

export default query
